import { BaseAlign, Font, Label, ScreenElement, TextAlign, vec } from "excalibur";
import { LevelOne } from "../../scenes/level-one/level-one";
import { DiceButton } from "./dice_button";

const padding = 16;

const dicePrices = [0, 50, 200, 500];

export class DiceButtons extends ScreenElement {
    constructor(private level: LevelOne, x: number, width: number, height: number) {
        super({
            pos: vec(x + padding, padding),
            width: width - padding * 2,
            height: height - padding * 2,
        });
    }

    public onInitialize() {
        const gridSize = 2;
        const diceWidth = this.width / gridSize;
        const diceHeight = this.height / gridSize;

        let dieCounter = 0;

        for (let j = 0; j < gridSize; j++) {
            for (let i = 0; i < gridSize; i++) {
                const pos = vec(i * diceWidth, j * diceHeight);
                const numDice = dieCounter + 1;
                const cost = dicePrices[dieCounter];

                const diceButton = new DiceButton(this.level, pos, diceWidth, diceHeight, numDice, cost, () => {
                    this.level.hud.bottomBar.diceDisplay.roll(numDice);
                    this.level.money -= cost;
                });

                this.addChild(diceButton);
                dieCounter++;
            }
        }
    }
}